export const ADD_MORE_ITEMS_PARAM = "addItems";
export const DEFAULT_ADD_MORE_ITEMS_SORT = "item_id.desc";
const ADD_MORE_ITEMS_ROUTE_KEYS = [
  ADD_MORE_ITEMS_PARAM,
  "projectId",
  "warehouse",
  "sort",
  "sq",
  "page",
  "limit",
  "categories",
  "costCenter",
];

// Carry only availability into checkout; catalog search/project filters do not
// belong to the cart route. Keep it in the URL so reloads retain the choice.
export const shoppingCartPath = (search, cartId) => {
  const params = new URLSearchParams();
  if (cartId) params.set("cartId", cartId);
  const availability = new URLSearchParams(search).get("availability");
  if (["all", "reserved", "in_stock"].includes(availability)) {
    params.set("availability", availability);
  }
  const query = params.toString();
  return `/shopping/cart${query ? `?${query}` : ""}`;
};

const getStoredShoppingProjectId = () => {
  try {
    return localStorage.getItem("shoppingProjectId") || "";
  } catch (_error) {
    return "";
  }
};

export const resolveAddMoreItemsProjectId = ({
  inventoryItems = {},
  defaultProjectId = "",
} = {}) => {
  const cartProjectId = Object.values(inventoryItems || {})[0]?.project?.id;
  return cartProjectId || defaultProjectId || getStoredShoppingProjectId() || "";
};

export const isAddMoreItemsOpen = search =>
  new URLSearchParams(search).get(ADD_MORE_ITEMS_PARAM) === "true";

export const updateAddMoreItemsRoute = ({
  location,
  navigate,
  updates,
  replace = false,
}) => {
  const params = new URLSearchParams(location.search);

  Object.entries(updates).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        params.delete(key);
      } else {
        params.set(key, value.join(","));
      }
      return;
    }

    if (value === null || value === undefined || value === "") {
      params.delete(key);
      return;
    }

    params.set(key, String(value));
  });

  navigate(
    {
      pathname: location.pathname,
      search: params.toString(),
    },
    { replace }
  );
};

export const openAddMoreItemsModal = ({
  location,
  navigate,
  projectId,
}) => {
  updateAddMoreItemsRoute({
    location,
    navigate,
    updates: {
      [ADD_MORE_ITEMS_PARAM]: "true",
      projectId,
      warehouse: "all",
      sort: DEFAULT_ADD_MORE_ITEMS_SORT,
    },
  });
};

export const closeAddMoreItemsModal = ({ location, navigate }) => {
  const updates = Object.fromEntries(
    ADD_MORE_ITEMS_ROUTE_KEYS.map(key => [key, null])
  );

  updateAddMoreItemsRoute({
    location,
    navigate,
    updates,
  });
};
